module.exports = __webpack_public_path__ + "static/media/po-Alternator.178ec313.png";